import {
  Table as MUITable,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';

import { Row } from './helpers';

interface Header {
  text: string;
  color?: string;
}

interface TableProps {
  headers: Header[];
  rows: Row[][] | Row[];
  title?: string;
  index?: number;
  untitledRadius?: boolean;
  lastChl?: boolean;
}

const styles = {
  display: 'flex',
  width: '100%',
  padding: '15px 0 0',
  color: 'white',
  justifyContent: 'center',
  fontSize: '1.4rem',
};

const Table: React.FC<TableProps> = ({ headers, rows, title, index, untitledRadius, lastChl }) => {
  const isFirstTable = index === 0;
  const theme = useTheme();
  return (
    <div>
      {title && (
        <Typography
          variant="h6"
          sx={{
            ...styles,
            backgroundColor: theme.palette.primary.main,
            fontWeight: 'bold',
            borderRadius: isFirstTable ? '1rem 1rem 0 0' : undefined,
          }}
        >
          {title}
        </Typography>
      )}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: lastChl ? '1rem' : untitledRadius ? '1rem 1rem 0 0' : 0,
          boxShadow: 'none',
        }}
      >
        <MUITable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: untitledRadius ? '1rem 1rem 0 0' : 0,
              }}
            >
              {headers.map((header) => (
                <TableCell
                  key={header.text}
                  sx={{
                    color: header.color || '#12344a',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {header.text}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ borderRadius: untitledRadius ? '0 0 1rem 1rem' : 0 }}>
            {Object.values(rows).map((row, rowIndex) => {
              return Array.isArray(row) ? (
                <TableRow sx={{ backgroundColor: rowIndex % 2 !== 0 ? '#f6f6f6' : 'white' }}>
                  {row?.map((column) => (
                    <TableCell
                      key={`cell-${rowIndex}-${rowIndex}`}
                      sx={{
                        textAlign: 'center',
                        color: column.bold ? '#12344a' : theme.palette.primary.main,
                      }}
                    >
                      <strong>{column.text}</strong>
                    </TableCell>
                  ))}
                </TableRow>
              ) : rowIndex < headers?.length ? (
                <TableCell
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  {row.bold ? (
                    <strong>{row.text}</strong>
                  ) : (
                    <Typography color="primary">
                      <strong>{row.text}</strong>
                    </Typography>
                  )}
                </TableCell>
              ) : null;
            })}
          </TableBody>
        </MUITable>
      </TableContainer>
    </div>
  );
};

export default Table;
